import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';

import Subnavigation from 'components/ui/layout/nav/Subnavigation';

import {reload} from 'modules/ui';

import 'style/components/ui/layout/nav/subnavigation.scss';

/** Subnavigation container for the second level of routes/menu */
class SubnavigationContainer extends Component {

    static propTypes = {
        dispatch: PropTypes.func.isRequired, // Function to dispatch actions
        routes:   PropTypes.array.isRequired, //The routes to show
        path:     PropTypes.string.isRequired, // The current selected path
        extra:    PropTypes.any // Extra content to show inside subnavigation at rightside
    };

    componentWillMount() {
        this.handleRefresh = this.handleRefresh.bind(this);
    }

    handleRefresh(refresh) {
        const {dispatch} = this.props;

        dispatch(refresh());
        dispatch(reload());
    }

    render() {
        const {extra, path, routes} = this.props;

        return (
            <Subnavigation
                extra={extra}
                path={path}
                routes={routes}
                onRefresh={this.handleRefresh}
            />
        );
    }
}

export default injectIntl(connect()(SubnavigationContainer));



// WEBPACK FOOTER //
// ./src/containers/ui/layout/nav/SubnavigationContainer.jsx